import { useEffect, useRef, useState } from 'react';

function useScrollReveal() {
  useEffect(() => {
    const elements = document.querySelectorAll('.scroll-reveal');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}

export default function Home() {
  useScrollReveal();

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=UnifrakturMaguntia&display=swap';
    document.head.appendChild(link);
  }, []);

  return (
    <div className="w-screen min-h-screen bg-black flex flex-col items-center justify-center overflow-hidden px-4">

      {/* Logo mit Glow + Fade-In + Hover-Zoom */}
      <div className="animate-fade-in hover-zoom animate-glow">
        <img
          src="https://static.readdy.ai/image/40a2d54780fde37d3589d54641b13eed/c81c5a4d9415626835f8dd29aacea699.jpeg"
          alt="EAST BLEEDS CREW Logo"
          className="w-full max-w-xs sm:max-w-sm md:max-w-lg lg:max-w-2xl object-contain"
        />
      </div>

      {/* Markenname mit Fade-In-Up + Delay */}
      <div className="flex flex-col items-center gap-2 mt-6 mb-5">
        <span
          className="text-white text-center animate-fade-in-up-delay-1"
          style={{ fontFamily: "'UnifrakturMaguntia', cursive", fontSize: "clamp(2.5rem, 8vw, 4.5rem)", letterSpacing: "0.15em" }}
          translate="no"
          lang="en"
        >
          E.B.C.
        </span>
        <span
          className="text-white/60 font-light text-center animate-fade-in-up-delay-2"
          style={{ fontFamily: "'Inter', sans-serif", fontSize: "clamp(0.6rem, 2.5vw, 0.875rem)", letterSpacing: "0.4em", marginLeft: "-0.4em" }}
          translate="no"
          lang="en"
        >
          &nbsp; &nbsp; &nbsp; &nbsp; EAST BLEEDS CREW &nbsp; &nbsp; &nbsp;&nbsp;
        </span>
      </div>

      {/* Wörter-Grid mit Scroll-Fade-In */}
      <div className="w-full max-w-3xl px-4 sm:px-8 mt-8 mb-12 grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 text-center">
        {["East", "Bleeds", "Crew"].map((word, i) => {
          const subtitles = [
            { main: "Geografisch · Richtung · Energie", sub: "Osten, Sonne, Anfang" },
            { main: "Emotional · Hart · Einsatz", sub: "Blut, Schweiß, Leidenschaft" },
            { main: "Gemeinschaft · Team · Bewegung", sub: "Zusammen, stärker, vereint" },
          ];
          const delayClass = i === 0
            ? 'scroll-reveal-delay-1'
            : i === 1
            ? 'scroll-reveal-delay-2'
            : 'scroll-reveal-delay-3';

          return (
            <div
              key={word}
              className={`scroll-reveal ${delayClass} flex flex-col items-center gap-3`}
            >
              <span
                className="text-white font-bold tracking-[0.3em] uppercase"
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontSize: "clamp(1.1rem, 4vw, 1.6rem)",
                }}
                translate="no"
                lang="en"
              >
                {word}
              </span>
              <div className="w-8 h-px bg-white/40 mx-auto"></div>
              <p
                className="text-white/50 text-xs tracking-widest uppercase leading-relaxed"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {subtitles[i].main}<br />
                <span className="text-white/30">{subtitles[i].sub}</span>
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
